import Form from '~components/form/js';
import Required from '~components/form/js/required';
import ValidationTypeExtend from 'components/validation-type';

const JS_ITEM = '[js-item]';
const JS_CLEAR = '[js-clear]';
const JS_REQUIRED = 'js-required';
const JS_VALIDATION_TYPE = 'js-validation-type';

class FormExtend extends Form {
  constructor(element) {
    super(element);

    this.checkFilledIn();

    this.clear();

    this.addUrlTitle();

    this.userFilter();

    this.richTextEditor();

    this.emptyOnClick();
  }

  emptyOnClick() {
    const inputs = [...this.element.querySelectorAll('[js-empty-on-click]')];

    inputs.forEach(input => {
      input.addEventListener('click', () => {
        input.value = '';
        input.blur();
        input.focus();
      });
    })
  }

  richTextEditor() {
    const editor = document.querySelector( '[js-rich-text-editor]' );

    if(editor) {
      CKEDITOR.replace(editor, {
        on: {
          instanceReady: function() {
            this.document.$.documentElement.classList.add('c-ckeditor');
            this.document.appendStyleSheet( '/assets/css/app.css' );
          },
          change: function() {
            editor.value = this.document.$.body.innerHTML;
          }
        }
      });

    }
  }

  userFilter() {
    const isUsersForm = this.element.hasAttribute('js-form-users');
    if(isUsersForm) {
      this.element.addEventListener('submit', event => {
        event.preventDefault();

        const firstname = this.element.querySelector('[js-form-firstname]');
        const province = this.element.querySelector('[js-form-province]');
        const organisation = this.element.querySelector('[js-form-organisation]');
        const surname = this.element.querySelector('[js-form-surname]');
        
        window.location.href = `${window.location.origin}/leden/search/${firstname.value ? firstname.value : 'all'}/${province.value}/${organisation.value}/${surname.value ? firstname.value : 'all'}`;
      })
    }
  }

  addUrlTitle() {
    const title = this.element.querySelector('[js-title]');
    const urlTitle = this.element.querySelector('[js-url-title]');
    const structureUrl = this.element.querySelector('[js-structure-url]');
    const randomString = Math.random().toString(36).substring(7);

    if(title) {
      title.addEventListener("blur", event => {
        const url = title.value.replace(/\W+/g, '-').replace(/\-$/, '').toLowerCase();

        urlTitle.value = `${url}-${randomString}` ;
        structureUrl.value = `${url}-${randomString}`;

      });
    }

  }

  clear() {
    const clearButtons = [...this.element.querySelectorAll(JS_CLEAR)];

    clearButtons.forEach(button => {
      button.addEventListener("click", (event) => {
        event.preventDefault();
        button.previousElementSibling.value = '';
        button.closest('[js-item]').classList.remove('has--value');
      });
    });
  }

  checkFilledIn() {
    const items = [...this.element.querySelectorAll(JS_ITEM)];
    items.forEach(item => {
      const fields = this.getFields(item);
      fields.forEach(field => {
        if(field.type !== 'file') {
          field.addEventListener("blur", () => {
            const toggle = field.value ? 'add' : 'remove';
            item.classList[toggle]('has--value');
          });
        }
      });
    });
  }

  responseMessage(error) {
    const emptyAfterSubmit = this.element.hasAttribute('js-form-submit-empty');
    const returnValue = this.element.getAttribute('js-return');
    this.element.classList.remove('is--loading');
    const statusElement = document.querySelector('[js-status]');
    const errorMessage = this.element.dataset.error;
    const successMessage = this.element.dataset.success;
    statusElement.classList.add('is--active');
    window.scrollTo(0, 0);
    
    if(emptyAfterSubmit) {
      this.element.reset();

      const items = [...this.element.querySelectorAll('[js-item]')];

      items.forEach(item => {
        item.classList.remove('has--value');
        item.classList.remove('has--error');

        const error = item.querySelector('[js-error]');
        if(error) error.parentElement.removeChild(error);
      });
    }

    if(error) {
      statusElement.classList.add('u-status--error');
      statusElement.classList.remove('u-status--success');
      statusElement.innerHTML = `
        <div class="container">${errorMessage ? errorMessage : 'Er is een fout opgetreden, probeer het opnieuw'}</div>
      `;
    } else {
      if(returnValue) {
        document.location.href = `${returnValue}`;
      } else {
        statusElement.classList.add('u-status--success');
        statusElement.classList.remove('u-status--error');
        statusElement.innerHTML = `
          <div class="container">${successMessage ? successMessage : 'Succesvol verzonden / geplaatst'}</div>
        `;
      }

    }
  }

  checkFields(item) {
    if(item.hasAttribute(JS_REQUIRED)) new Required(this.element, this.error, item);
    if(item.hasAttribute(JS_VALIDATION_TYPE)) new ValidationTypeExtend(this.element, this.error, item);
  }
}

export default FormExtend;
